import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faList} from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import axios from "axios";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import LoantovalueAddModal from "../partials/LoantovalueAddModal";
import LoantovalueUpdateModal from "../partials/LoantovalueUpdateModal";
import { toast, ToastContainer} from "react-toastify";
import Moment from 'moment';
import $ from 'jquery';
import * as myConstList from "../../actions/baseUrl";

const baseUrl = myConstList.baseUrl

class Loantovalue extends Component {

    constructor(props) {
        super(props);

        this.columns = [
            {
                key: "id",
                text: "Id",
                className: "id",
                align: "left",
                sortable: true,
            },
             {
                key: "currency_name",
                text: "Currency Name",
                className: "currency_name",
                align: "left",
                sortable: true
            },
            {
                key: "value",
                text: "Loan Value",
                className: "value",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                          {record.value}%
                        </Fragment>
                    );
                }
            },
          
            {
                key: "created_at",
                text: "Date",
                className: "created_at",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                          {Moment(record.created_at).format('lll')}
                        </Fragment>
                    );
                }
            },
            {
                key: "action",
                text: "Action",
                className: "action",
                width: 200,
                align: "left",
                sortable: false,
                cell: record => {
                    return (
                        <Fragment>
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => this.historyData(record)}
                                style={{marginRight: '5px'}} disabled={this.state.isConfirmDisabled}>
                                History
                            </button>
                            <button
                                data-toggle="modal"
                                data-target="#update-user-modal"
                                className="btn btn-primary btn-sm"
                                onClick={() => this.editRecord(record)}
                                style={{marginRight: '5px'}}>
                                <i className="fa fa-edit"></i>
                            </button>
                            <button
                                className="btn btn-danger btn-sm"
                                onClick={() => this.deleteRecord(record)}>
                                <i className="fa fa-trash"></i>
                            </button>
                        </Fragment>
                    );
                }
            }
        ];

        this.config = {
            page_size: 10,
            length_menu: [ 10, 20, 50 ],
            filename: "Loantovalue List",
            no_data_text: 'No record found!',
            button: {
               
                print: true,
                csv: true
            },
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: [],
            currencyList: [],
            currentRecord: {
                id: '',
                value: '',
                currency_id: '',
                country_name: '',
            },
            pageTitle:'',
            isConfirmDisabled:false 
        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        if (this.props.auth.user.loan !==undefined && this.props.auth.user.loan !==1 ) {
            this.props.history.push("/dashboard");
        }
        this.getData()
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.auth.user.loan !==undefined && this.props.auth.user.loan !==1 ) {
            this.props.history.push("/dashboard");
        }
        if (nextProps.loantovaluedata !== undefined
            && nextProps.loantovaluedata.loanvalue !== undefined
            && nextProps.loantovaluedata.loanvalue.data !== undefined
            && nextProps.loantovaluedata.loanvalue.data.message !== undefined) {
           
            $('#update-user-modal').modal('hide');
            $('#add-user-modal').modal('hide');
            toast(nextProps.loantovaluedata.loanvalue.data.message, {
                position: toast.POSITION.TOP_CENTER
            });
            this.setState({ errors: {currencyImage:''}});
        }

        this.getData()
    }

    getData() {
        axios
            .post(baseUrl + "/api/loan-to-value-data")
            .then(res => {
                this.setState({ records: res.data})
            })
            .catch()
            
            axios
            .get(baseUrl + "/api/crypto-data")
            .then(res => {
                this.setState({ currencyList: res.data})
            })
            .catch()
            this.setState({ isConfirmDisabled:false});
    }

    editRecord(record) {
        this.setState({ currentRecord: record});
    }

    historyData(record) {
        axios
            .post(baseUrl + "/api/loan-to-value-data", {currency_id: record.currency_id})
            .then(res => {
                this.setState({ records: res.data})
                this.setState({ isConfirmDisabled:true});
                this.setState({ pageTitle:record.currency_name});
            })
            .catch()
    }

    deleteRecord(record) {
        axios
            .post(baseUrl + "/api/loan-to-value-delete", {id: record.id})
            .then(res => {
                if (res.status === 200) {
                   toast(res.data.message, {
                       position: toast.POSITION.TOP_CENTER,
                   })
                }
            })
            .catch();
        this.getData();
    }

    pageChange(pageData) {
        console.log("OnPageChange", pageData);
    }

    render() {
        return (
            <div>
                <Navbar/>
                <div className="d-flex" id="wrapper">
                    <Sidebar />
                    <LoantovalueAddModal currencyList={this.state.currencyList}/>
                    <LoantovalueUpdateModal record={this.state.currentRecord}  currencyList={this.state.currencyList}/>
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <button className="btn btn-link mt-3" id="menu-toggle"><FontAwesomeIcon icon={faList}/></button>
                            <button className="btn btn-outline-primary float-right mt-3 mr-2" data-toggle="modal" data-target="#add-user-modal"><FontAwesomeIcon icon={faPlus}/> Add Loan Value</button>
                            <h4 className="mt-2 text-primary">{this.state.pageTitle} Loan Value List</h4>
                            <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                            />
                        </div>
                    </div>
                    <ToastContainer/>
                </div>
            </div>
        );
    }

}

Loantovalue.propTypes = {
    auth: PropTypes.object.isRequired,
    loantovaluedata: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    loantovaluedata: state.loantovaluedata,
    records: state.records
});

export default connect(
    mapStateToProps
)(Loantovalue);
